import React, { useEffect } from "react";
import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
// import Address from "../../img/address.png";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useContext } from "react";
import { ThemeContext } from "../../context";

const Contact = () => {
  const initialValues = {
    user_name: "",
    user_email: "",
    user_subject: "",
    message: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.user_name) {
      errors.user_name = "Username is required!";
    }
    if (!values.user_email) {
      errors.user_email = "Email is required!";
    } else if (!regex.test(values.user_email)) {
      errors.user_email = "Email must be valid !";
    }
    if (!values.user_subject) {
      errors.user_subject = "Subject is required!";
    } else if (values.user_subject.length < 3) {
      errors.user_subject = "Subject must be more than 3 character";
    } else if (values.user_subject.length > 15) {
      errors.user_subject = "Subject must be less than 15 character";
    }
    if (!values.message) {
      errors.message = "Message is required!";
    } else if (values.message.length < 3) {
      errors.message = "Message must be more than 3 character";
    } else if (values.message.length > 300) {
      errors.message = "Message must be less than 300 character";
    }

    return errors;
  };

  const formRef = useRef();

  const [done, setDone] = useState(false);

  const theme = useContext(ThemeContext);
  const dark = theme.state.darkMode;

  const onSubmit = (e) => {
    e.preventDefault();

    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      emailjs
        .sendForm(
          "service_f91tolh",
          "template_slglp93",
          formRef.current,
          "user_5I9kaftKNFSJSQfQ7mPFO"
        )
        .then(
          (result) => {
            console.log(result.text);
            setFormValues(initialValues);
            setDone(true);
          },
          (error) => {
            console.log(error.text);
          }
        );
    }
  }, [formErrors, isSubmit, initialValues]);

  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Contact Me</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              +93799225732
            </div>
            <div className="c-info-item">
              <img src={Email} alt="" className="c-icon" />
              fayeq.rahmat@gmail.com
            </div>
            {/* <div className="c-info-item">
              <img src={Address} alt="" className="c-icon" />
              Kabul-Afghanistan
            </div> */}
          </div>
        </div>
        <div className="c-right">
          <form
            ref={formRef}
            onSubmit={onSubmit}
            style={{ backgroundColor: dark ? "silver" : "rgb(245, 230, 210)" }}
          >
            <input
              type="text"
              name="user_name"
              placeholder="Name"
              value={formValues.user_name}
              onChange={handleChange}
              style={{
                backgroundColor: dark && "#333",
                color: dark && "white",
              }}
            />
            <div className="error">{formErrors.user_name}</div>
            <input
              type="text"
              name="user_email"
              placeholder="Email"
              value={formValues.user_email}
              onChange={handleChange}
              style={{
                backgroundColor: dark && "#333",
                color: dark && "white",
              }}
            />
            <div className="error">{formErrors.user_email}</div>
            <input
              type="text"
              name="user_subject"
              placeholder="Subject"
              value={formValues.user_subject}
              onChange={handleChange}
              style={{
                backgroundColor: dark && "#333",
                color: dark && "white",
              }}
            />
            <div className="error">{formErrors.user_subject}</div>
            <textarea
              rows="5"
              name="message"
              placeholder="Message"
              value={formValues.message}
              onChange={handleChange}
              style={{
                backgroundColor: dark && "#333",
                color: dark && "white",
              }}
            />
            <div className="error">{formErrors.message}</div>

            <button>Submit</button>
            <div className="message">
              {done && "Thanks for your message, I will contact you soon."}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
